import classnames from 'classnames'
import React, { Component } from 'react'

// TODO: link to the place directly on google maps(?)
// https://www.google.com/maps/place/33+Greene+St,+New+York,+NY+10013/@40.7218592,-74.0198387,14z
// https://www.google.com/maps/place/18+Rue+Saint-Marc,+75002+Paris,+France/@48.8707164,2.3381513,14z
class Place extends Component {
  render () {
    const { image, city, country, street, zip } = this.props
    return (
      <div className='place p2 center'>
        <div
          className={classnames('place__media mb2 mx-auto', {
            'flex items-center': !!image
          })}
          ref={element => {
            this.mapElement = element
          }}
        >
          {image && <img src={image} alt={`${city} office`} />}
        </div>
        <div className='h3 blue mb1'>{city}</div>

        <div className='place__text'>
          {street}
          <br />
          {city} {zip}
          <br />
          {country}
          <br />
        </div>
      </div>
    )
  }
}

export default Place



// WEBPACK FOOTER //
// ./frontend/scripts/react/components/Place.js